<script>
import { defineComponent } from "vue";
import SidebarRouteLink from "@kit/components/SidebarRouteLink.vue";
import NavMainSearch from "@kit/components/NavMainSearch.vue";
import SideNavDrawerBase from "@kit/components/SideNavDrawerBase.vue";
import { searchWidgetMobile, sideDrawer } from "@project/themes";
import { getCurrentYear } from "@kit/utils/Formats"

export default defineComponent({
  name: "SizeNavDrawer",
  setup() {
    return { searchWidgetMobile, sideDrawer, getCurrentYear };
  },
  components: {
    SideNavDrawerBase,
    SidebarRouteLink,
    NavMainSearch,
  },
});
</script>

<style>
.side-nav-1 {
  font-size: 1.2rem;
  color: white;
}

.side-nav-1 > a {
  color: white;
  transition: 0.3s color linear;
  text-decoration: none;
}
.side-nav-1 > a:hover {
  color: white;
}
.side-nav-1 > a:visited {
  color: #eeeeee;
}

@media (max-width: 960px) {
}

</style>

<template>
  <SideNavDrawerBase :theme="sideDrawer">
    <template #nav-items="{ active }">

      <h1 class="sb sb-text" style="color:white; margin-top:30px;">Treasure Coast Avionics</h1>

      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/">Home</SidebarRouteLink>
      </div>

      <div class="sb sb-v side-nav-1">
      <a href="/#services">Services</a>
      </div>

      <div class="sb sb-v side-nav-1">
      <a href="/#work">Recent Installs</a>
      </div>

      <div class="sb sb-v side-nav-1">
      <SidebarRouteLink to="/news">News</SidebarRouteLink>
      </div>

      <div class="sb sb-v side-nav-1">
      <a href="/#brands">Brands</a>
      </div>

      <div class="sb sb-v side-nav-1">
      <SidebarRouteLink to="/contact-us">Contact Us</SidebarRouteLink>
      </div>

      <div class="sb sb-v side-nav-1">
      <a href="/#visit">Find Us</a>
      </div>

      <div class="sb sb-v side-nav-1">
        <a class="call-btn" style="text-align:center;" href="tel:+17724643148">(772) 464-3148</a>
      </div>
  
      <div class="sb sb-v side-nav-1" style="font-size:0.7rem;">
        © {{ getCurrentYear() }} Treasure Coast Avionics
      </div>

    </template>
  </SideNavDrawerBase>
</template>
